import { useContext } from 'react';

import { SocketContext } from '../../socket/SocketProvider';

const NEW_ALERT = 'new-alert';

export default function useEmitAlert() {
  const { socket } = useContext(SocketContext);

  const sendNewAlertDataToSocket = (newAlertData) => {
    console.log(`The form state at submit is ${JSON.stringify(newAlertData)}`);

    if (!socket) {
      console.log(`Error: socket not connected; new alert not sent.`);
      return;
    }

    socket.emit(NEW_ALERT, JSON.stringify({ newAlert: newAlertData }), () => {
      console.log('New alert data successfully sent to socket.');
    });
  };

  return { sendNewAlertDataToSocket };
}
